<template>
  <el-dialog
    :visible.sync="showEdit"
    width="700px"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="简历"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="curriculum-vitae"
  >
    <el-table :data="data" :row-class-name="rowClassName">
      <el-table-column width="180" prop="id" label="姓名">
         <template slot-scope="{row}">
        {{row.curriculum_vitae.nickname}}
         </template>
      </el-table-column>
      <el-table-column label="性别" width="130">
        <template slot-scope="{row}">
          {{row.curriculum_vitae.sex==1?'男':'女'}}
        </template>
      </el-table-column>
      <el-table-column width="220" label="投递时间" show-overflow-tooltip>
        <template slot-scope="{row}">
          {{row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button size="mini" @click="$emit('showBiographicalNotes',row.user_id,row.created_at,row.index,row.mark_id,row.id)">
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import commonModels from '@/common/models/common-models'
export default {
  name: "curriculum-vitae",
  props:{
    show:{
      type:Boolean,
      default:false
    },
    data:{
      type:Array,
      default:[]
    }
  },
  filters: {
    parseTime(time) {
      return commonModels.formatTime(time, 'Y/M/D h:m:s')
    },
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  },
  data(){
    return{
      showEdit:false
    }
  },
  methods:{
    rowClassName({row, rowIndex}){
      row.index=rowIndex
      if(rowIndex%2==0){
        return "while-row"
      }else{
        return "gray-row"
      }
    },
    handleOpen(){

    },
    handleClose(){
      this.$emit("update:show",false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-service/axj-work/component/curriculum-vitae/index.vue